import React from 'react';

function Footer() {

    return (
        <div>
            <footer className="footer">
                <p className="mb-0">Ironhack Barcelona</p>
                <p className="mb-0">Víctor Ronda</p>
                <p className="mb-0">Amalia González</p>
            </footer>
        </div>
    )
}

export default Footer